var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('section',{staticClass:"bg"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.load)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }